import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import sx from '../sx.js';
import { toggleStyledComponent } from '../internal/utils/toggleStyledComponent.js';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';
import { clsx } from 'clsx';
import classes from './Details.module.css.js';
import { useMergedRefs } from '../internal/hooks/useMergedRefs.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS_MODULES_FEATURE_FLAG = 'primer_react_css_modules_team';
const StyledDetails = toggleStyledComponent(CSS_MODULES_FEATURE_FLAG, 'details', styled.details.withConfig({
  displayName: "Details__StyledDetails",
  componentId: "sc-1jjccgx-0"
})(["& > summary{list-style:none;}& > summary::-webkit-details-marker{display:none;}", ";"], sx));
const Root = /*#__PURE__*/React.forwardRef(({
  className,
  children,
  ...rest
}, forwardRef) => {
  const enabled = useFeatureFlag(CSS_MODULES_FEATURE_FLAG);
  const detailsRef = React.useRef(null);
  const ref = useMergedRefs(forwardRef, detailsRef);
  const [hasSummary, setHasSummary] = useState(false);
  useEffect(() => {
    const {
      current: details
    } = detailsRef;
    if (!details) {
      return;
    }
    const updateSummary = () => {
      const summary = details.querySelector('summary:not([data-default-summary])');
      setHasSummary(!!summary);
    };

    // Update summary on mount
    updateSummary();
    const observer = new MutationObserver(() => {
      updateSummary();
    });
    observer.observe(details, {
      childList: true,
      subtree: true
    });
    return () => {
      observer.disconnect();
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledDetails, _extends({
    className: clsx(className, {
      [classes.Details]: enabled
    })
  }, rest, {
    ref: ref
  }), !hasSummary && /*#__PURE__*/React.createElement(Details.Summary, {
    "data-default-summary": true
  }, 'See Details'), children);
});
Root.displayName = 'Details';
function Summary({
  as,
  children,
  ...props
}) {
  const Component = as !== null && as !== void 0 ? as : 'summary';
  return /*#__PURE__*/React.createElement(Component, _extends({
    as: Component === 'summary' ? null : 'summary'
  }, props), children);
}
Summary.displayName = "Summary";
Summary.displayName = 'Summary';
const Details = Object.assign(Root, {
  Summary
});

export { Summary, Details as default };
